__turbopack_context__.v({
  "carousel": "Carousel-module-scss-module__bRseiG__carousel",
  "slide": "Carousel-module-scss-module__bRseiG__slide",
});
